module.exports = __webpack_public_path__ + "static/media/demonstration-audience.f4a0a8f9.svg";